import { render } from "./DocumentExtraTab.vue?vue&type=template&id=3ace3dd3&scoped=true"
import script from "./DocumentExtraTab.vue?vue&type=script&lang=js"
export * from "./DocumentExtraTab.vue?vue&type=script&lang=js"

import "./DocumentExtraTab.vue?vue&type=style&index=0&id=3ace3dd3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ace3dd3"]])

export default __exports__